export function datingDraft(record = {}) {
  const present = value => value !== null && value !== undefined && value !== '';
  const listed = record.possibleYears?.length ? record.possibleYears.join(', ') : record.years || '';
  return {
    mode: present(record.year) ? 'exact' : listed ? 'list' :
      present(record.yearFrom) && present(record.yearTo) ? 'range' :
      present(record.yearFrom) ? 'from' : present(record.yearTo) ? 'to' : 'unknown',
    year: record.year ?? '', yearFrom: record.yearFrom ?? '', yearTo: record.yearTo ?? '', years: listed,
  };
}

export function datingPayload(draft, lang = 'RU') {
  const parse = value => {
    if (!/^\d{1,4}$/.test(String(value).trim()) || Number(value) < 1)
      throw new Error(lang === 'EN' ? 'Enter a whole year from 1 to 9999.' : 'Укажите целый год от 1 до 9999.');
    return Number(value);
  };
  const result = { year: null, yearFrom: null, yearTo: null, possibleYears: [] };
  if (draft.mode === 'exact' && String(draft.year ?? '').trim() !== '') result.year = parse(draft.year);
  if (draft.mode === 'from' || (draft.mode === 'range' && draft.yearFrom !== '' && draft.yearFrom != null)) result.yearFrom = parse(draft.yearFrom);
  if (draft.mode === 'to' || (draft.mode === 'range' && draft.yearTo !== '' && draft.yearTo != null)) result.yearTo = parse(draft.yearTo);
  if (draft.mode === 'range' && result.yearFrom != null && result.yearTo != null && result.yearFrom > result.yearTo)
    throw new Error(lang === 'EN' ? 'The start year must not exceed the end year.' : 'Начало периода не может быть позже конца.');
  if (draft.mode === 'list' && String(draft.years ?? '').trim() !== '') {
    result.possibleYears = [...new Set(String(draft.years).trim().split(/[,;\s]+/).map(parse))].sort((a, b) => a - b);
    if (result.possibleYears.length > 200) throw new Error(lang === 'EN' ? 'Enter at most 200 years.' : 'Укажите не более 200 лет.');
  }
  return result;
}

export function formatDating(record = {}, lang = 'RU') {
  if (record.year != null && record.year !== '') return String(record.year);
  if (record.possibleYears?.length) return [...new Set(record.possibleYears)].sort((a, b) => a - b).join(', ');
  if (record.yearFrom != null && record.yearTo != null) return `${record.yearFrom}–${record.yearTo}`;
  if (record.yearFrom != null) return `${lang === 'EN' ? 'from' : 'с'} ${record.yearFrom}`;
  if (record.yearTo != null) return lang === 'EN' ? `up to ${record.yearTo} (inclusive)` : `до ${record.yearTo} включительно`;
  return '';
}

export function datingSearchUrl(record) {
  const params = new URLSearchParams({ searchType: 'all' });
  if (record.year != null) params.set('year', record.year);
  else {
    if (record.yearFrom != null) params.set('yearFrom', record.yearFrom);
    if (record.yearTo != null) params.set('yearTo', record.yearTo);
    if (record.possibleYears?.length) params.set('years', record.possibleYears.join(','));
  }
  return '/search?' + params.toString();
}

export function validateYearFilters(filters, lang) {
  // Validate combinations too: URLs may contain both bounds and a discrete list.
  for (const key of ['year', 'yearFrom', 'yearTo']) {
    if (filters[key]) datingPayload({ mode: 'exact', year: filters[key] }, lang);
  }
  if (filters.yearFrom && filters.yearTo) datingPayload({ mode: 'range', ...filters }, lang);
  if (filters.years) datingPayload({ mode: 'list', years: filters.years }, lang);
}
